import { genericJourneyResolverMapping } from '@dxb-web-ui-framework/mocks/msw/types';
import { genericMapToHandlers } from '@dxb-web-ui-framework/mocks/msw/utils/genericMapToHandlers';
import { ecommbx } from '../../index';

const deviceMap: genericJourneyResolverMapping[] = [
  {
    url: /\/api\/private\/devices\/authorizations\/otp\/\d+/,
    response: () => ecommbx.authorizationsOTPData,
    responseHeaders: { code: '204' },
    method: 'put',
  },
  {
    url: /\/api\/private\/devices\/authorizations\/\d+\/resend/,
    response: () => ecommbx.resendAuthorizationData,
    responseHeaders: { code: '204' },
    method: 'post',
  },
  {
    url: /\/api\/private\/devices\/web\/authorizations\/\d+\/status/,
    response: () => ecommbx.fallbackOTPData,
    method: 'post',
  },
  {
    url: /\/api\/private\/devices\/web\/authorizations\/\d+\/status/,
    response: () => ecommbx.webAuthorizationStatusData,
    responseHeaders: { code: '200' },
    method: 'get',
  },
  { url: /\/api\/private\/devices/, response: () => ecommbx.devicesData, method: 'get' },
  {
    url: /\/api\/private\/devices\/deletion/,
    response: () => null,
    method: 'put',
    responseHeaders: { code: '204' },
  },
  {
    url: /\/api\/private\/devices\/deletion\/authorization/,
    response: () => ecommbx.deleteDeviceAuthorizationData,
    method: 'post',
    responseHeaders: { code: '201' },
  },
  {
    url: /\/api\/private\/devices/,
    response: () => ecommbx.registerNewDeviceData,
    method: 'post',
    responseHeaders: { code: '201' },
  },
];

const deviceHandlers = deviceMap.map(genericMapToHandlers);

export { deviceHandlers };
